module.exports = __webpack_public_path__ + "assets/images/entertainment_phase2.f465194c0af14c0dbfd7e958348eb685.svg";